import { Circle as CircleStyle, Fill, Stroke, Style } from 'ol/style.js';

const VIOLET  = 'rgba(236,72,153,';
const PENDING = 'rgba(180,130,0,';   // amber for unverified/pending

// Verified / confirmed — solid violet
const POLYGON_STYLE = new Style({
  stroke: new Stroke({ color: `${VIOLET}0.9)`, width: 2 }),
  fill:   new Fill ({ color: `${VIOLET}0.2)` }),
});
const LINE_STYLE = new Style({
  stroke: new Stroke({ color: `${VIOLET}0.9)`, width: 3 }),
});
const POINT_STYLE = new Style({
  image: new CircleStyle({
    radius: 7,
    stroke: new Stroke({ color: `${VIOLET}1)`,  width: 2 }),
    fill:   new Fill ({ color: `${VIOLET}0.35)` }),
  }),
});

// Unverified / pending — dashed amber
const POLYGON_PENDING = new Style({
  stroke: new Stroke({ color: `${PENDING}0.85)`, width: 1.5, lineDash: [6, 4] }),
  fill:   new Fill ({ color: `${PENDING}0.1)` }),
});
const LINE_PENDING = new Style({
  stroke: new Stroke({ color: `${PENDING}0.85)`, width: 2, lineDash: [6, 4] }),
});
const POINT_PENDING = new Style({
  image: new CircleStyle({
    radius: 6,
    stroke: new Stroke({ color: `${PENDING}0.85)`, width: 2, lineDash: [4, 3] }),
    fill:   new Fill ({ color: `${PENDING}0.2)` }),
  }),
});

export function communityReportStyleFunction(feature) {
  const pending = feature.get('status') === 'unverified';
  const type    = feature.getGeometry()?.getType();
  if (type === 'Point' || type === 'MultiPoint')
    return pending ? POINT_PENDING : POINT_STYLE;
  if (type === 'LineString' || type === 'MultiLineString')
    return pending ? LINE_PENDING : LINE_STYLE;
  return pending ? POLYGON_PENDING : POLYGON_STYLE;
}
